"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _src = require("@seedlang/utils/src");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var CardArrowBoxWrapper = function CardArrowBoxWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      _classCallCheck(this, _class2);
      return _callSuper(this, _class2, arguments);
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "userInputBottom",
      get: function get() {
        var padding;
        if (_state.DeckUI.layout.isNative && _state.DeckUI.layout.isAndroid) {
          padding = 35;
        } else if (_state.DeckUI.layout.isNative && _state.DeckUI.layout.hasNotch) {
          padding = 25;
        } else {
          padding = 15;
        }
        return _state.DeckUI.layout.userInputHeight + padding;
      }
    }, {
      key: "onHideArrowBox",
      value: function onHideArrowBox(arrowBox) {
        _state.DeckUI.onHideArrowBox();
        if ((0, _src.isPresent)(arrowBox) && (0, _lodash.isFunction)(arrowBox.onChange)) {
          arrowBox.onClose(arrowBox.slug);
        }
      }
    }, {
      key: "filteredArrowBoxes",
      get: function get() {
        var _this$props$card,
          _this = this;
        if ((_this$props$card = this.props.card) !== null && _this$props$card !== void 0 && (_this$props$card = _this$props$card.cardState) !== null && _this$props$card !== void 0 && _this$props$card.showHelp) {
          return [];
        }
        return this.props.possibleArrowBoxes ? this.arrowBoxes.filter(function (item) {
          return _this.props.possibleArrowBoxes.includes(item.slug);
        }) : [];
      }
    }, {
      key: "cardTextTop",
      get: function get() {
        return _state.DeckUI.layout.cardTextHeight + _state.DeckUI.layout.userInputHeight;
      }
    }, {
      key: "word",
      get: function get() {
        return _state.DeckUI.currentCard ? _state.DeckUI.currentCard.word : {};
      }
    }, {
      key: "arrowBoxes",
      get: function get() {
        var _DeckUI$currentCard;
        return [{
          slug: 'compareYourGermanOnboarding',
          onboarding: true,
          title: "Compare Your ".concat(_state.DeckUI.deck.languageName),
          message: "Compare your recorded ".concat(_state.DeckUI.deck.languageName, " to the ").concat(_state.DeckUI.deck.languageName, " in the video."),
          onClose: this.designateUiElementAsSeen,
          bottom: _state.DeckUI.layout.userInputHeight + 10,
          arrowPosition: 'bottom',
          left: 0,
          right: 0,
          height: 100,
          width: 300
        }, {
          slug: 'commentOnboarding',
          onboarding: true,
          title: 'Ask Our Teachers',
          message: 'Ask our teachers a question about any word or sentence.',
          onClose: this.designateUiElementAsSeen,
          arrowPosition: 'right',
          arrowBoxBackground: _state.DeckUI.showVideoPlayer ? '#FFF' : '#CCC',
          top: ((_DeckUI$currentCard = _state.DeckUI.currentCard) === null || _DeckUI$currentCard === void 0 ? void 0 : _DeckUI$currentCard.cardTypeSlug) === 'comprehend' ? 70 : 30,
          right: 60,
          height: 100,
          width: 300,
          justifyContent: 'flex-end'
        }, {
          slug: 'reviewIconOnboarding',
          onboarding: true,
          title: 'Reviews',
          message: 'Click this icon if you would like to add this card to a review deck.',
          onClose: this.designateUiElementAsSeen,
          arrowPosition: 'rightTop',
          arrowFill: '#585858',
          top: 5,
          right: 60,
          height: 100,
          width: 300,
          justifyContent: 'flex-end'
        }, {
          slug: 'noteOnboarding',
          onboarding: true,
          title: 'Take Notes',
          message: 'Click here to write a private note that will be attached to this card.',
          onClose: this.designateUiElementAsSeen,
          arrowPosition: 'right',
          arrowBoxBackground: _state.DeckUI.showVideoPlayer ? '#FFF' : '#CCC',
          top: 70,
          right: 60,
          height: 100,
          width: 300,
          justifyContent: 'flex-end'
        }, {
          slug: 'vocabCardOnboarding',
          onboarding: true,
          title: 'More Information',
          message: 'Click here to see more information about this word.',
          onClose: this.designateUiElementAsSeen,
          arrowPosition: 'right',
          arrowBoxBackground: _state.DeckUI.showVideoPlayer ? '#FFF' : '#CCC',
          top: 70,
          right: 60,
          height: 100,
          width: 300,
          justifyContent: 'flex-end'
        }, {
          slug: 'switchLanguagesOnboarding',
          onboarding: true,
          title: 'Switch Languages',
          message: 'Click the flag icon to switch to the English translation.',
          onClose: this.designateUiElementAsSeen,
          arrowPosition: 'rightTop',
          arrowFill: '#585858',
          top: 150,
          right: 65,
          height: 100,
          width: 300,
          justifyContent: 'flex-end'
        }, {
          slug: 'toggleKeyboardMicrophoneOnboarding',
          onboarding: true,
          title: _state.AppUI.user.vocabCardAudio ? 'Switch to Keyboard' : 'Switch to Microphone',
          message: _state.AppUI.user.vocabCardAudio ? 'Click this icon if you would rather type the translation.' : 'Click this icon if you would rather speak the translation.',
          onClose: this.designateUiElementAsSeen,
          arrowPosition: 'topRight',
          arrowFill: '#585858',
          arrowBoxBackground: '#CCC',
          top: 60,
          right: 3,
          height: 100,
          width: 300,
          justifyContent: 'flex-end'
        }, {
          slug: 'wordInformationOnboarding',
          onboarding: true,
          title: 'Word Information',
          message: 'Click on any word that you want to learn more about.',
          onClose: this.designateUiElementAsSeen,
          arrowPosition: 'bottom',
          bottom: this.cardTextTop + 10,
          left: 0,
          right: 0,
          height: 100,
          width: 300,
          justifyContent: 'center'
        }, _defineProperty({
          slug: 'spacedRepetitionOnboarding',
          onboarding: true,
          title: 'Evaluate Your Review',
          message: 'How hard was it to remember this review? The time (1 day) describes when you will see this card again.',
          onClose: this.designateUiElementAsSeen,
          arrowPosition: 'bottom',
          bottom: 10,
          left: 0,
          right: 0,
          height: 120,
          width: 300,
          justifyContent: 'center'
        }, "onClose", this.designateUiElementAsSeen), {
          slug: 'helpMeOnboarding',
          onboarding: true,
          title: 'Help',
          message: 'Click \'Help\' if you need help with a translation.',
          onClose: this.designateUiElementAsSeen,
          arrowPosition: 'bottom',
          bottom: _state.DeckUI.layout.isNative ? 50 : 10,
          left: 0,
          right: 0,
          height: 120,
          width: 300,
          justifyContent: 'center'
        }, {
          slug: 'shortcutsOnboarding',
          onboarding: true,
          title: 'Shortcuts',
          message: 'You can press a number key on your keyboard to activate the buttons below.',
          onClose: this.designateUiElementAsSeen,
          arrowPosition: 'bottom',
          bottom: 10,
          left: 0,
          right: 0,
          height: 120,
          width: 300,
          justifyContent: 'flex-start'
        }, {
          slug: 'caseClickOnWord',
          title: 'Click on a Word',
          message: 'To read more information about its case.',
          onboarding: true,
          onClose: this.designateUiElementAsSeen,
          top: 5,
          left: 0,
          right: 0,
          width: 300,
          arrowPosition: 'bottom'
        }, {
          slug: 'caseUnderline',
          title: 'Look at the Colors',
          message: 'To know what case each word is in.',
          onboarding: true,
          onClose: this.designateUiElementAsSeen,
          top: 5,
          left: 0,
          right: 0,
          width: 300,
          arrowPosition: 'bottom'
        }, {
          slug: 'helpMe',
          title: 'Click on a Word',
          subText: 'The word order is of the literal translation.',
          arrowPosition: 'bottom',
          top: _state.DeckUI.layout.videoHeight - _state.DeckUI.layout.cardArrowBoxHeight - 20,
          left: 0,
          right: 0,
          width: _state.DeckUI.layout.cardArrowBoxWidth,
          height: _state.DeckUI.layout.cardArrowBoxHeight,
          justifyContent: 'center'
        }, {
          slug: 'answer',
          title: 'Answer the Question',
          subText: 'Answer using your own words.',
          arrowPosition: 'bottom',
          bottom: this.userInputBottom,
          left: 0,
          right: 0,
          width: _state.DeckUI.layout.cardArrowBoxWidth,
          height: _state.DeckUI.layout.cardArrowBoxHeight,
          justifyContent: 'center'
        }, {
          slug: 'translate',
          title: "Translate to ".concat(_state.DeckUI.deck.languageName),
          subText: 'Click \'Help\' if stuck.',
          arrowPosition: 'bottom',
          bottom: this.userInputBottom,
          left: 0,
          right: 0,
          width: _state.DeckUI.layout.cardArrowBoxWidth,
          height: _state.DeckUI.layout.cardArrowBoxHeight,
          justifyContent: 'center'
        }, {
          slug: 'translateVocab',
          title: "Translate ".concat(this.word && this.word.wordType ? "this ".concat(this.word.wordType.formattedName) : "to ".concat(_state.DeckUI.deck.languageName)),
          subText: this.word ? 'Click \'Help\' if stuck.' : null,
          arrowPosition: 'bottom',
          bottom: this.userInputBottom,
          left: 0,
          right: 0,
          width: _state.DeckUI.layout.cardArrowBoxWidth,
          height: _state.DeckUI.layout.cardArrowBoxHeight,
          justifyContent: 'center'
        }, {
          slug: 'repeat',
          title: "Repeat the ".concat(_state.DeckUI.deck.languageName),
          subText: _state.DeckUI.user.listeningComprehensionMode ? 'Try without viewing the subtitles.' : null,
          bottom: _state.AppUI.layout.isNative ? this.userInputBottom + 10 : this.userInputBottom + 5,
          left: 0,
          right: 0,
          arrowPosition: 'bottom',
          width: _state.DeckUI.layout.cardArrowBoxWidth,
          height: _state.DeckUI.layout.cardArrowBoxHeight,
          justifyContent: 'center'
        }, {
          slug: 'repeat_word',
          title: 'Repeat the Word',
          subText: 'Do your best!',
          bottom: this.userInputBottom,
          left: 0,
          right: 0,
          arrowPosition: 'bottom',
          width: _state.DeckUI.layout.cardArrowBoxWidth,
          height: _state.DeckUI.layout.cardArrowBoxHeight
        }, {
          slug: 'repeat_sound',
          title: 'Repeat the Sound',
          subText: 'Do your best!',
          bottom: this.userInputBottom,
          left: 0,
          right: 0,
          arrowPosition: 'bottom',
          width: _state.DeckUI.layout.cardArrowBoxWidth,
          height: _state.DeckUI.layout.cardArrowBoxHeight
        }, {
          slug: 'read_aloud',
          title: 'Record Yourself',
          subText: 'By clicking the record button.',
          bottom: this.userInputBottom,
          left: 0,
          right: 0,
          arrowPosition: 'bottom',
          width: _state.DeckUI.layout.cardArrowBoxWidth,
          height: _state.DeckUI.layout.cardArrowBoxHeight
        }, {
          slug: 'describe',
          title: 'Tell a Story',
          subText: 'Describe what happens in this scene.',
          bottom: this.userInputBottom,
          left: 0,
          right: 0,
          arrowPosition: 'bottom',
          width: _state.DeckUI.layout.cardArrowBoxWidth,
          height: _state.DeckUI.layout.cardArrowBoxHeight
        }];
      }
    }, {
      key: "designateUiElementAsSeen",
      value: function designateUiElementAsSeen(slug) {
        _state.DeckUI.designateUiElementAsSeen(slug);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          onHideArrowBox: this.onHideArrowBox,
          filteredArrowBoxes: this.filteredArrowBoxes
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "userInputBottom", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userInputBottom"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onHideArrowBox", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onHideArrowBox"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filteredArrowBoxes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filteredArrowBoxes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTextTop", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTextTop"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "word", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "word"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "arrowBoxes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "arrowBoxes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "designateUiElementAsSeen", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "designateUiElementAsSeen"), _class2.prototype), _class2)) || _class;
};
CardArrowBoxWrapper.displayName = 'CardArrowBoxWrapper';
var _default = exports["default"] = CardArrowBoxWrapper;